'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navbarAdminApp = exports.NavbarAdmin = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = require('redux-logger');

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _NavbarAdmin = require('./containers/NavbarAdmin');

var _NavbarAdmin2 = _interopRequireDefault(_NavbarAdmin);

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

require('./styles/cadmus-navbar-admin.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loggerMiddleware = (0, _reduxLogger.createLogger)();

// eslint-disable-next-line no-underscore-dangle
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
var store = (0, _redux.createStore)(_reducers2.default, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default, loggerMiddleware)));

var CadmusNavbarAdminApp = function CadmusNavbarAdminApp(_ref) {
  var baseUrl = _ref.baseUrl,
      pagesUrl = _ref.pagesUrl;
  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(_NavbarAdmin2.default, { baseUrl: baseUrl, pagesUrl: pagesUrl })
  );
};

CadmusNavbarAdminApp.propTypes = {
  baseUrl: _propTypes2.default.string.isRequired,
  pagesUrl: _propTypes2.default.string.isRequired
};

exports.NavbarAdmin = _NavbarAdmin2.default;
exports.navbarAdminApp = _reducers2.default;
exports.default = CadmusNavbarAdminApp;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/index.js
// module id = 311
// module chunks = 0